module.exports = __webpack_public_path__ + "media/images/online_review_pana-139a9632a09aff8f92f46031803627ac.png";